
export default {
  data() {
    return {
      token: {
        Authorization: localStorage.getItem('token'),
      },
    }
  },
  methods: {},
}
